import {useContext} from "react";
import {ProjectFormNavigationContext} from "./project-form-navigation-context-props.ts";

const useProjectFormNavigationContext = () => {
    const context = useContext(ProjectFormNavigationContext);
    if (!context) {
        throw new Error('Must be defined in ProjectFormNavigationContext');
    }
    return context;
}

export default useProjectFormNavigationContext;